import { colocationEmailsSubTypesOptions } from '../colocations/colocation.interface';
import { oltEmailSubTypeOptions } from '../provisioning/olt.interface';
import {
  createEnumList,
  createEnumOptions,
} from '../shared/enum-option.interface';
import { ticketTypeOptions } from '../tickets/ticket.interface';
import { MailType } from './email.interface';

export interface IEmailsSubGroupSettings {
  emails: string[];
  disabled: boolean;
  sendToCreator?: boolean;
}

export interface IEmailsGroupSettings extends IEmailsSubGroupSettings {
  subGroups?: {
    [subType: string]: IEmailsSubGroupSettings;
  };
}

export interface IEmailsSettings
  extends Record<EmailTypesGroup, IEmailsGroupSettings> {}

export enum EmailTypesGroup {
  orders = 'orders',
  report = 'report',
  olt = 'olt',
  tickets = 'tickets',
  other = 'other',
  general = 'general',
  profilactic = 'profilactic',
  colocation = 'colocation',
  nonDocOrders = 'nonDocumentedOrders',
}

export const emailTypesMap: Map<MailType, EmailTypesGroup> = new Map([
  [MailType.orderChanged, EmailTypesGroup.orders],
  [MailType.reportPublished, EmailTypesGroup.report],
  [MailType.ticketCreated, EmailTypesGroup.tickets],
  [MailType.ticketMessageCreated, EmailTypesGroup.tickets],
  [MailType.oltSubmitted, EmailTypesGroup.olt],
  [MailType.oltAssignedSp, EmailTypesGroup.olt],
  [MailType.oltAllowedIsp, EmailTypesGroup.olt],
  [MailType.ticketAssigned, EmailTypesGroup.tickets],
  [MailType.setPassword, EmailTypesGroup.general],
  [MailType.customNotification, EmailTypesGroup.other],
  [MailType.profilacticCreated, EmailTypesGroup.profilactic],
  [MailType.newProfilacticComment, EmailTypesGroup.profilactic],
  [MailType.profilacticUpdated, EmailTypesGroup.profilactic],
  [MailType.colocationCreated, EmailTypesGroup.colocation],
  [MailType.colocationPriceQuote, EmailTypesGroup.colocation],
  [MailType.colocationConstructionOrder, EmailTypesGroup.colocation],
  [MailType.colocationFinished, EmailTypesGroup.colocation],
  [MailType.colocationReopened, EmailTypesGroup.colocation],
  [MailType.colocationCancelled, EmailTypesGroup.colocation],
  [MailType.colocationAssigned, EmailTypesGroup.colocation],
  [MailType.colocationPortReservation, EmailTypesGroup.colocation],
  [MailType.colocationPortReservationCancelled, EmailTypesGroup.colocation],
  [MailType.newColocationComment, EmailTypesGroup.colocation],
  [MailType.profilacticNotification, EmailTypesGroup.profilactic],
  [MailType.nonDocumentedOrders, EmailTypesGroup.nonDocOrders],
]);

export const emailTypesGroupOptions = createEnumOptions<EmailTypesGroup>({
  [EmailTypesGroup.general]: { label: 'Globálne nastavenia' },
  [EmailTypesGroup.orders]: { label: 'Objednávky' },
  [EmailTypesGroup.report]: { label: 'Reporty' },
  [EmailTypesGroup.olt]: { label: 'OLT' },
  [EmailTypesGroup.tickets]: { label: 'Tikety' },
  [EmailTypesGroup.profilactic]: { label: 'Servisná profylaktika' },
  [EmailTypesGroup.colocation]: { label: 'Kolokácie' },
  [EmailTypesGroup.nonDocOrders]: { label: 'Nezdokumentované objednávky' },
  [EmailTypesGroup.other]: { label: 'Iné' },
  _default: { label: '-' },
});

const ticketSubTypes = createEnumList(ticketTypeOptions);
const orderSubTypes = createEnumList(
  createEnumOptions({
    migration: { label: 'Migrácia' },
    apChange: { label: 'Zmena odberného miesta' },
    _default: { label: '-' },
  }),
);
const colocationSubTypes = createEnumList(colocationEmailsSubTypesOptions);
const oltSubTypes = createEnumList(oltEmailSubTypeOptions);

export const emailSubGroupsMap: Map<
  EmailTypesGroup,
  {
    label: string;
    value: unknown;
  }[]
> = new Map([
  [EmailTypesGroup.tickets, ticketSubTypes],
  [EmailTypesGroup.orders, orderSubTypes],
  [EmailTypesGroup.colocation, colocationSubTypes],
  [EmailTypesGroup.olt, oltSubTypes],
]);

export interface IUserEmailSettings {
  disabledEmailTypes?: MailType[];
  userId: string;
}
